<div class="row border border-dark rounded p-2 mx-1 my-2 bg-light">
  <div class="col-md-12 ">
    <img src="assets/img/info-76.svg" class="help-img">
    <div class="help-text">
      <ng-content></ng-content>
    </div>
  </div>
</div>
